import React from "react";
import "./src/styles/globals.css";
import "@fontsource/open-sans/300.css";
import "@fontsource/open-sans";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";
import { AppProvider } from "./src/context/AppContext";

export const wrapRootElement = ({ element }) => {
	return <AppProvider>{element}</AppProvider>;
};
